import { Suspense, lazy } from "react";
import { AuthProvider } from './contexts/Auth.context'
import { StoreProvider } from './contexts/Store.context'
import PaystackPayment from "./modals/Paystack";
import { ModalProvider } from './contexts/Modal.context'
import { QueryClientProvider } from "react-query";
import { queryClientConfig } from "./lib/utils"
import { Switch, BrowserRouter as Router, Route } from "react-router-dom"
import ErrorBoundary from './components/ErrorBoundary';
import PrivateRoute from "./components/PrivateRoute"
// import LandingPage from "./pages/LandingPage"
import Header from "./components/Header";
import FullPageCenterItems from "./components/FullPageCenterItems";
import ToastNotifications from "./modals/ToastNotifications";
import Spinner from "./components/Spinner";

const Login = lazy(() => import("./pages/Login"))
const Signup = lazy(() => import("./pages/Signup"))
const Dashboard = lazy(() => import("./pages/Dashboard"))
const Transactions = lazy(() => import("./pages/Transactions"))
const Subscriptions = lazy(() => import("./pages/Subscriptions"))
const Loans = lazy(() => import("./pages/Loans"))
const Profile = lazy(() => import("./pages/Profile"))

export default function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={
        <FullPageCenterItems fullscreen>
          <Spinner />
        </FullPageCenterItems>
      }>
        <Router>
          <QueryClientProvider client={queryClientConfig}>
            <AuthProvider>
              <div className="app h-screen flex flex-col antialiased bg-indigo-50">
                <Header />
                <Switch>
                  <Route exact path={['/', '/login']}><Login /></Route>
                  {/* <Route exact path='/'><LandingPage /></Route> */}
                  <Route exact path='/signup'><Signup /></Route>

                  <StoreProvider>
                    <ModalProvider>
                      <div className="px-6 flex justify-end relative">
                        <ToastNotifications />
                      </div>
                      <PrivateRoute exact path="/dashboard" component={Dashboard} />
                      <PrivateRoute exact path={['/transactions']} component={Transactions} />
                      <PrivateRoute exact path={['/subscriptions']} component={Subscriptions} />
                      <PrivateRoute exact path={['/loans']} component={Loans} />
                      <PrivateRoute exact path={['/profile']} component={Profile} />
                      <PaystackPayment />
                    </ModalProvider>
                  </StoreProvider>
                </Switch>
              </div>
            </AuthProvider>
          </QueryClientProvider>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}